import { useCallback,useState } from 'react';
import { Card,Col,Container,Row } from 'react-bootstrap';
import PaginatedTableComponent,{ Column } from '../../components/ui/paginated-table';
import { CacheReloadResponse } from '../../interface/cache';
import cacheService from '../../service/cache.service';
import CacheReloaderFormContainerComponent from './cache-reloader-form-container';
import './index.css';
import { timezoneName } from '../../config/env';
import { arrayToCorrectTimezone } from '../../utils/date-utils';

export default function CacheReloaderComponent() {
  const [selectedPage, setSelectedPage] = useState<number>(0);
  const [cacheContentItems, setCacheContentItems] = useState<any[]>([]);

  const getCacheData = useCallback((cache: string | undefined | null) => {
    if (cache == null) {
      setCacheContentItems([]);
    } else {
      cacheService.getCacheHistory(cache).then(response => {
        // Descending order
        response.sort((a, b) => b.loadSequence - a.loadSequence);
        setCacheContentItems(response);
      });
    }
  }, []);

  const addToCacheData = useCallback(
    (cacheResponse: CacheReloadResponse) => {
      setCacheContentItems(prev => {
        // Add and sort descending
        return [...prev, cacheResponse].sort((a, b) => b.loadSequence - a.loadSequence);
      });
    },
    [],
  );

  const [columns] = useState<Column[]>(
    (
      [
        {
          id: 'cacheName',
          label: 'Cache Name',
        },
        {
          id: 'description',
          label: 'Description',
        },
        {
          id: 'loadSequence',
          label: 'Load Sequence',
        },
        {
          id: 'changeDt',
          label: timezoneName === '' ? 'Change Date (GMT)' : `Change Date (${timezoneName})`,
          format: (value: number[]) => arrayToCorrectTimezone(value),
        },
        {
          id: 'changeSource',
          label: 'Change Source',
        },
      ] as Column[]
    ).filter(column => column),
  );

  return (
    <Container className="cache-reloader">
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <Card.Title>Cache Reloader</Card.Title>
            </Col>
          </Row>
          <Card.Text>Update cache.</Card.Text>
          <CacheReloaderFormContainerComponent getCacheData={getCacheData} addToCacheData={addToCacheData} />
        </Card.Body>
      </Card>
      {cacheContentItems.length > 0 && (
        <Card>
          <Card.Body>
            <Row>
              <Col>
                <Card.Title>Preview</Card.Title>
              </Col>
            </Row>
            <Row>
              <Col className="justify-content-center">
                <PaginatedTableComponent
                  columns={columns}
                  rows={cacheContentItems}
                  rowIdPropName="id"
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  sx={{ maxWidth: 'calc(100vw - 307px - 2*24px - 32px - 38px - 19px)' }}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}
